export class Employee
{
    employeeId: string;
    employeeEmailId: string;

    constructor(id: string, emailId: string) {
        this.employeeId = id;
        this.employeeEmailId = emailId;
    }
}